import { render, staticRenderFns } from "./CopyInfoDialog.vue?vue&type=template&id=bb2b5f58&scoped=true"
import script from "./CopyInfoDialog.vue?vue&type=script&lang=js"
export * from "./CopyInfoDialog.vue?vue&type=script&lang=js"
import style0 from "./CopyInfoDialog.vue?vue&type=style&index=0&id=bb2b5f58&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb2b5f58",
  null
  
)

export default component.exports